Ext.define('SA.data.quickreport.QuickReportTemplate', {
    constructor(country, type, sections) {
        this.country = country;
        this.type = type;
        this.sections = sections;
    },

    getAttributes() {
        var nestedAttributes = this.sections.map(getSectionAttributes);

        return Ext.Array.flatten(nestedAttributes);

        function getSectionAttributes(section) {
            return section.attributeTuples.map(getTupleAttributes);
        }

        function getTupleAttributes(tuple) {
            return Ext.Array.clean(tuple.attributes); 
        }
    },

    getCountry() {
        return this.country;
    },

    getId() {
        return this.getCountry() + ' - ' + this.getType();
    },

    getSections() {
        return this.sections;
    },

    getType() {
        return this.type;
    }
});